/* eslint-disable class-methods-use-this */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-param-reassign */
import { Controller } from "@hotwired/stimulus";
import { trackAmplitudeEvents } from "../utils/events/amplitude";

export default class extends Controller {
  static targets = ["tab", "content"];

  static values = {
    tracking: String,
    trackingYearly: String,
    trackingMonthly: String,
  };

  connect() {
    const trackingValue = JSON.parse(this.trackingValue);
    this.tracking = {
      yearly: { ...trackingValue, ...JSON.parse(this.trackingYearlyValue) },
      monthly: { ...trackingValue, ...JSON.parse(this.trackingMonthlyValue) },
    };
  }

  toggleTabs(event) {
    const activeTab = event.target.dataset.tab;
    const contents = this.contentTarget.children;
    const tabs = this.tabTargets;

    const eventProperties = this.tracking[activeTab];
    trackAmplitudeEvents("switch_tab_plus_subscription", eventProperties);

    tabs.forEach((tab) => {
      tab.classList.remove("active");
    });

    event.target.classList.add("active");

    for (const i in contents) {
      if (Object.prototype.hasOwnProperty.call(contents, i)) {
        if (contents[i].dataset.tab === activeTab) {
          contents[i].classList.add("active");
        } else {
          contents[i].classList.remove("active");
        }
      }
    }
  }
}
